import React, { useEffect } from "react";
import { classDetailAPI } from "../../../../Api/apiUtils";
import { Table, EmptyState } from "../../../../ui";
import "./classDetails.scss";

const COMPLETED_LEVELS = ["Preparatory", "Intermediate", "Proficient", "Advanced"];

const ClassDetails: React.FC<any> = ({ studentId, courseId }) => {
    const [classDetails, setClassDetails] = React.useState<any>();
    const fetchData = async (studentId:any,courseId:any) => {
        let response = await classDetailAPI(studentId, courseId);
        console.log("Class Details API Response:", response); // ✅ Debugging
        setClassDetails(response);
    }
  useEffect(() => {
    console.log("courseId ID:", courseId);
    fetchData(studentId, courseId);
  }, [courseId]);

  return (
    <div className="class-details">
      {classDetails && classDetails.length ? <Table caption="Classes by level">
        <thead>
          <tr>
            <th rowSpan={2}>Level</th>
            <th className="ds-num" rowSpan={2}>Total (Purchased + Free)</th>
            <th className="class-details__group" colSpan={4}>Completed (According to purchased Classes)</th>
            <th className="ds-num" rowSpan={2}>Remaining</th>
          </tr>
          <tr>
            {COMPLETED_LEVELS.map((level) => (
              <th key={level} className="ds-num">{level}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {classDetails.map((item:any, index:number) => {
            const completedLevel = item.completed.completed_level;
            const completedCount = item.completed.completed_count;
            return (
              <tr key={index}>
                <td>{item.purchased_level}</td>
                <td className="ds-num">{item.total}</td>
                {COMPLETED_LEVELS.map((level) => (
                  <td key={level} className="ds-num">
                    {level === completedLevel ? completedCount : ""}
                  </td>
                ))}
                <td className="ds-num">{item.remaining}</td>
              </tr>
            );
          })}
        </tbody>
      </Table> : classDetails && classDetails.length === 0 ? <EmptyState title="No classes found" description="This student has no classes for the selected course yet." /> : ""}
    </div>
  );
};

export default ClassDetails;
